<script lang="ts" setup>
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';

defineProps<{
  imageNumber: number;
}>();
</script>

<template>
  <WhereToConsultCard title="iDeCoの相談先" :image-number="imageNumber">
    <p>
      iDeCo公式サイトの「<NuxtLink
        href="https://www.ideco-koushiki.jp/otoiawase/"
        external
        target="_blank"
        >お問い合わせ</NuxtLink
      >」では、iDeCoを検討中の方や加入中の方、自動移管者の方に向けて各種コールセンターを設置しています。
    </p>
    <p>
      また、当サイト「オカネコ」では、国内最大級の家計診断・相談サービスを提供中で、スマホから3分程度で終わる簡単な質問に回答するだけで、あなたの家計状況を分析し、複数のプロからアドバイスがもらえます。
    </p>
    <p>
      今後のライフプランの作成に加え、資産形成の具体的な方法、iDeCoの運用先を選ぶための専門的な意見など、個別チャットでお金に関するお悩みをご相談いただけます。
    </p>
    <p>
      相談内容は非公開かつ匿名なので、ぜひ安心してオカネコ無料相談をご活用ください。
    </p>
  </WhereToConsultCard>
</template>

<style lang="scss" module></style>
